import * as React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Container, Button } from '@mui/material';
import '../css/menu.css';
import AppBard from '../Componentes/appbar';
import NavigationMenu from '../Componentes/NavigationMenu';


export default function Menuscitalsa({ componet }) {
  const [spacing, setSpacing] = React.useState(2);
  const [isActive, setIsActive] = React.useState(true);


  return (
    <Container style={{ backgroundColor: "", width: "100%", maxWidth: "100%", padding: 0 }}>
      <Grid sx={{ flexGrow: 1 }} container spacing={0}>
        <Grid item xs={12}>
          <AppBard></AppBard>
          <NavigationMenu />
          <Grid container justifyContent="center" spacing={spacing} >
            <Container className={isActive ? 'Menu' : 'MenuBorroso'} style={{ backgroundColor: "", width: "100%", maxWidth: "100%", paddingLeft: "0px", paddingRight: "0px" }}>
              {componet}
            </Container>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}
